import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { AppConstant } from '../../../../../../Assests/AppConstant';
import CustomButtonSS from '../../../../../Common/CustomButton/CustomButtonSS';
import EditIcon from '../../../../../../Assests/Images/edit-icon-new.png';
import SSPopup from '../../../../../Common/Popup/SSPopup/SSPopup';
import DrilldownTableSS from '../../../../Components/Dashboard/DefaultDashboard/DrillDownReports/Common/DrilldownTableSS';
import CustomTooltip from '../../../../../Common/Tooltip/CustomTooltip';

const StandingAppointmentsList = (props) => {
    const dispatch = useDispatch();
    const { standingAppointmentsList, handleEdit, handleDelete, themeSelected, whObj, searchStr } = props;
    const [showDeleteModel, setShowDeleteModel] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [filteredList, setFilteredList] = useState([]);
    const [isListLoading, setListLoading] = useState(props?.isListLoading);
    const navigate = useNavigate();
    const listHeaders = [
        { id: 'WarehouseName', name: 'Warehouse Name' },
        { id: 'DockName', name: 'Dock Name' },
        { id: 'CarrierName', name: 'Carrier Name' },
        { id: 'StartEndTime', name: 'Start & End Date' },
        { id: 'ApptStartDateTime', name: 'Appt Start Time' },
        { id: 'DurationMins', name: 'Duration(mins)' },
        { id: 'Frequency', name: 'Frequency' },
        { id: 'WeeklyData', name: 'Appointment Days' },
        // { id: 'IsActive', name: 'Status' },
        // { id: 'RuleProcessingStatus', name: 'Status' },
        { id: 'CreatedOn', name: 'Created On' },
        { id: 'TimeSlot', name: 'Time Slot' },
        { id: 'StandingBlockLeadTime', name: 'Lead Time (in days)' },
        { id: 'actions', name: 'Actions' },
    ];

    const deleteHandler = (id) => {
        setSelectedId(id);
        setShowDeleteModel(true);
    }

    const popupBtnHandler = (text) => {
        if (text === AppConstant.commonStrings.yes) {
            handleDelete(selectedId);
        }
        setShowDeleteModel(false);
        setSelectedId(null);
    }

    const showDeleteConfirmation = () => {
        const popupObj = {
            id: 'showDeleteConfirmationStandingAppt',
            modalLabel: 'showDeleteConfirmationStandingAppt',
            showClose: true,
            showfooter: true,
            showHeader: true,
            modalSize: 'md',
            title: "Delete Standing Appointment Block",
            bodyText: `By deleting standing appointment block all the upcoming appointments will be cancelled. ${AppConstant.commonStrings.areYouSure} delete this standing appointment block?`,
            backdrop: "static",
            footerBtn: {
                btn1: { show: true, text: AppConstant.commonStrings.yes },
                btn2: { show: true, text: AppConstant.commonStrings.no }
            },
        }
        return <SSPopup {...popupObj} popupBtnHandler={popupBtnHandler} closepopup={() => setShowDeleteModel(false)} themeSelected={themeSelected} showModal={showDeleteModel} />
    }


    const actionsButton = (appt, index) => {
        return (
            <div className='d-flex justify-content-around align-items-center'>
                <img
                    src={EditIcon}
                    alt='edit'
                    className='editIconPO-ss'
                    data-bs-toggle="modal"
                    data-bs-target={`#createStandingAppointment`}
                    onClick={() => handleEdit(appt)}
                />
                <CustomButtonSS
                    className={`no-border no-bg`}
                    onClick={() => deleteHandler(appt.ID)}
                    isIcon={true}
                    iconClass={"fa-regular fa-trash-can fa-lg"}
                />
            </div>
        )
    }


    /**
         * Function to render operational days
         * @param {*} data 
         * @returns 
         */
    const getOperationalDays = (data) => {
        const displayDays = [
            { label: 'S', dayNumber: 7 },
            { label: 'M', dayNumber: 1 },
            { label: 'T', dayNumber: 2 },
            { label: 'W', dayNumber: 3 },
            { label: 'T', dayNumber: 4 },
            { label: 'F', dayNumber: 5 },
            { label: 'S', dayNumber: 6 },
        ];

        return (
            <>
                <div className='d-flex justify-content-center gap-1 f-wrap'
                    data-testid={AppConstant.dataTestId.operational_days}
                    data-tip={AppConstant.dock.StandingToolTip.operational_daysTooltip}
                    data-for={AppConstant.dataTestId.operational_days}
                >
                    {displayDays.map((day, index) => {
                        const isSelected = data.includes(day.dayNumber);
                        return (
                            <span key={index} className={isSelected ? 'color-green' : 'color-red'}>
                                {day.label}
                            </span>
                        );
                    })}
                </div>
                <CustomTooltip
                    id={AppConstant.dataTestId.operational_days}
                    position="top"
                    type="dark"
                    multiline={true}
                />
            </>
        );
    };


    useEffect(() => {
        if (searchStr) {
            const lowercasedValue = searchStr.toLowerCase();
            const filteredData = standingAppointmentsList.filter(item =>
                (item.WarehouseName && item.WarehouseName.toLowerCase().includes(lowercasedValue)) ||
                (item.CarrierName && item.CarrierName.toLowerCase().includes(lowercasedValue)) ||
                (item.DockName && item.DockName.toLowerCase().includes(lowercasedValue))
            );
            setFilteredList(filteredData);
        } else {
            setFilteredList(standingAppointmentsList);
        }
    }, [searchStr, standingAppointmentsList]);

    useEffect(() => {
       
            setListLoading(props.isListLoading)
  
    }, [props.isListLoading])
    const formatListDataDrillDown = (data) => {
        return data.map((el, index) => {
            return {
                id: index,
                0: el.WarehouseName || '-',
                1: el.DockName || '-',
                2: el.CarrierName || '-',
                3: `${moment.utc(el.StartDateTime).format('MM/DD/YYYY')} - ${moment.utc(el.EndDateTime).format('MM/DD/YYYY')}`,
                4: el?.ApptStartDateTime ? moment.utc(el.ApptStartDateTime).format('HH:mm')  : '-',
                // 4: el.ApptStartDateTime ? el.ApptStartDateTime : '-',
                5: el.DurationMins || '-',
                6: el.Frequency || '-',
                7: el?.WeeklyData ? getOperationalDays(el?.WeeklyData) : '-',
                // 8: el?.RuleProcessingStatus === 'IN_PROGRESS' ? 'In Progress' : (el?.RuleProcessingStatus ?? '-'),
                8: `${moment(el.CreatedOn).format(AppConstant.commonStrings.MM_DD_YYYY_dateFormat)}\n${moment(el.CreatedOn).format(AppConstant.commonStrings.HH_mm_dateFormat)}` || '-',
                9: el.StandingBlockTimeSlot || '-',
                10: (el.StandingBlockLeadTime !== '' && el.StandingBlockLeadTime !== null && el.StandingBlockLeadTime !== undefined) ? Number(el.StandingBlockLeadTime) / 24 : 0,
                11: actionsButton(el, index),
            }
        })
    }

    return (
        <>
            <DrilldownTableSS
                themeSelected={themeSelected}
                bodyData={(filteredList || []).length ? formatListDataDrillDown(filteredList) : []}
                titleData={listHeaders}
                showCollapse={false}
                showInput={false}
                showSort={false}
                loaderArray={12}
                initiateDrillDownReport={isListLoading}
            />
            {showDeleteConfirmation()}
        </>
    );
}

export default StandingAppointmentsList;